import { render, staticRenderFns } from "./DisplayTagButton.vue?vue&type=template&id=baca5abe&scoped=true"
import script from "./DisplayTagButton.vue?vue&type=script&lang=js"
export * from "./DisplayTagButton.vue?vue&type=script&lang=js"
import style0 from "./DisplayTagButton.vue?vue&type=style&index=0&id=baca5abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baca5abe",
  null
  
)

export default component.exports